import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Tailwind-aware className combiner. `clsx` lets us write conditional class
 * maps (`{'bg-or-orange-500': isActive}`), then `twMerge` resolves conflicts
 * so later classes win (e.g. overriding a default padding from a variant).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
